import Vue from "vue";
import UUID from 'vue-uuid';
import './plugins/vuetify'
import App from "./App.vue";
import router from "./router/";
import store from "./store.js";
import "./registerServiceWorker";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import '@fortawesome/fontawesome-free/css/all.css'
import axios from 'axios';
import Vuetify from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.config.productionTip = false;

//AXIOS DEFAULTS
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

// AXIOS INTERCEPTORS (manejo errores api global)
axios.interceptors.response.use(null, function(error) {
  if(error.response.status== '401'){
    localStorage.removeItem('token');
    window.getApp.$emit('APP_LOGOUT');
  }
  throw error;
});


//vuelayers
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css'; // needs css-loader
Vue.use(VueLayers);

//vue2-google-maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAGkKaf3YnMQ6gJogbPpoiTEyWeSehVEqA',
    libraries: 'places',
  },
})


Vue.use(UUID);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
